export default __webpack_public_path__ + "static/media/Development.39823d9d.svg";